import { LanguageModelRequest } from '#types/System.Agents.types';
import type { ResponseHandler } from '../types';
import { readTextStream } from '../streamParsers';

export const streamHandler: ResponseHandler<LanguageModelRequest> = {
    isApplicable: (_r): _r is LanguageModelRequest => true,
    handle: async (response, _request, { onData, onComplete }) => {
        if (!response.body) throw new Error('Failed to get readable stream');
        if (!onData) throw new Error('onData required for streaming mode');
        await readTextStream(response.body.getReader(), onData, () => onComplete?.());
    },
};
